import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties'
import { motion } from 'framer-motion';
import { portfolioMo } from 'data/portfolio'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';
import './style.css'

const Third = () => {
  const [list, setList] = useState<any>([]);
  const navigate = useNavigate()

  useEffect(() => {
    setList(chunkArray(portfolioMo, 3))
  }, [])

  const goDetail = (id: number) => {
    navigate(`/portfolioDetail?id=${id}`)
  }

  const chunkArray = <T,>(arr: T[], size: number): T[][] =>
    arr.reduce((acc: T[][], _, index) =>
      (index % size === 0 ? [...acc, arr.slice(index, index + size)] : acc), []
    );

  return (
    <div className="flex justify-start items-center bg-white py-24 w-full min-h-screen">
      <div className='container'>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
        >
          {list.map((item: any, idx: number) => (
            <SwiperSlide key={idx}>
              {
                item.map((items: any, index: number) => (
                  <motion.div
                    key={index}
                    transition={{ delay: 0.1 * idx }}
                    onClick={() => goDetail(items.id)}
                    style={{
                      backgroundImage: `url(${items.background})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      width: '100%',
                      height: '30vh',
                    }}
                    className="group flex justify-center items-center mb-4 rounded-xl w-full font-bold text-white cursor-pointer select-none"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                  >
                    <div className='flex flex-col justify-center items-center gap-4 bg-[rgba(0,0,0,0.4)] rounded-xl w-full h-full'>
                      {
                        items.logo &&
                        <items.logo className="w-16 h-16" />
                      }
                      <div className='flex flex-col items-center'>
                        <p className='text-sm'>{items.name}</p>
                        <p className='text-sm'>{items.period}</p>
                        <p className="text-xs">{items.description}</p>
                      </div>
                    </div>
                  </motion.div>
                ))
              }
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default Third
